export default __webpack_public_path__ + "static/media/titleMobile3x.2e4f717d.png";